import React from 'react';
import { PageSettings } from "../../config/page-settings";
import { withRouter } from 'react-router-dom';
import { inject } from 'mobx-react';
import { Panel, PanelBody, PanelHeader } from '../../components/panel/panel.jsx';
import DataTable from './../../components/content/data-table.jsx';
import $ from 'jquery';
import './../../config/util';
import Const from './../../config/const';
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import strings from '../../lang/strings';
const moment = require('moment');

class Hourly extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);
        this.state = {
            type: 0, // 일별
            date_from: moment().subtract(1, 'year').format('YYYY-MM-DD'),
            date_to: moment().format('YYYY-MM-DD'),
        };
    }

    componentDidMount() {
    }

    refreshTable = (refresh) => {
        this.tblMember.draw(refresh);
    };

    onChangeDate(id, value, format) {
        this.setState({
            [id]: typeof value === 'object' ? value.format(format) : value
        });
    }

    changeViewMode = (type) => {
        this.setState({
            type: type
        }, () => {
            this.refreshTable(true);
        });
    };

    render() {
        let self = this;
        let columnNo = 2;
        let columnDefs = [...Array(24).keys()].map((item, index) => {
            return {
                targets: [columnNo++], data: 'h' + index, orderable: false,
                render: function (value) {
                    return Number(value) > 0 ? value.currencyFormat() : '<span style="color: grey">-</span>';
                }
            }
        });

        return (
            <div className='pl-0 pr-0'>
                <Panel>
                    <PanelHeader noButton={true}>{strings.sta_hourly}</PanelHeader>
                    <PanelBody>
                        <div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-horizontal form-inline'>
                                        <div className="btn-group">
                                            <button
                                                className={'btn btn-sm ' + (this.state.type === 0 ? 'btn-success' : 'btn-white')}
                                                onClick={() => this.changeViewMode(0)}>{strings.daily}</button>
                                            <button
                                                className={'btn btn-sm ' + (this.state.type === 1 ? 'btn-success' : 'btn-white')}
                                                onClick={() => this.changeViewMode(1)}>{strings.monthly}</button>
                                        </div>
                                        <DateTime
                                            dateFormat={'YYYY-MM-DD'}
                                            timeFormat={false}
                                            inputProps={{ placeholder: strings.select_start_time }}
                                            defaultValue={this.state.date_from}
                                            closeOnSelect={true}
                                            className="ml-md-2"
                                            id="date_from"
                                            onChange={(e) => this.onChangeDate('date_from', e, 'YYYY-MM-DD')} />
                                        <DateTime
                                            dateFormat={'YYYY-MM-DD'}
                                            timeFormat={false}
                                            inputProps={{ placeholder: strings.select_end_time }}
                                            defaultValue={this.state.date_to}
                                            closeOnSelect={true}
                                            className="ml-md-1"
                                            id="date_to"
                                            onChange={(e) => this.onChangeDate('date_to', e, 'YYYY-MM-DD')} />
                                        <button type='button' className='btn btn-success btn-sm ml-md-2' onClick={this.refreshTable}>{strings.search}</button>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12 mt-3'>
                                    <DataTable ref={(ref) => this.tblMember = ref}
                                        options={{
                                            columnDefs: [
                                                {
                                                    targets: [0], data: 'date', orderable: false,
                                                    render: function (value) {
                                                        if (self.state.type === 1) {
                                                            return value;
                                                        } else {
                                                            const week_idx = moment(value).weekday();
                                                            const week_color = week_idx == 0 ? 'red' : week_idx == 6 ? 'blue' : '';
                                                            return value + ` <span style="color: ${week_color}">(${strings.const.WEEK_LIST[week_idx]})</span>`;
                                                        }
                                                    }
                                                },
                                                {
                                                    targets: [1], data: null, orderable: false,
                                                    createdCell: function (td, value, item) {
                                                        $(td).css('background-color', '#DAE3F380');

                                                        let total_count = 0;
                                                        [...Array(24).keys()].forEach((it, idx) => {
                                                            total_count = total_count + Number(item['h' + idx]);
                                                        })
                                                        total_count = Math.round(total_count / 24 * 100) / 100;
                                                        return $(td).html(total_count.currencyFormat());
                                                    }
                                                }
                                            ].concat(columnDefs),
                                            order: [[1, 'DESC']],
                                            ajax: {
                                                url: 'sta/login',
                                                data: function (req) {
                                                    req.columns = null;
                                                    req.date_from = self.state.date_from;
                                                    req.date_to = self.state.date_to;
                                                    req.is_monthly = self.state.type;
                                                }
                                            },
                                            drawCallback: function () {
                                            },
                                            fnCreatedRow: function (row, data, dataInd) {
                                            }
                                        }}>
                                        <thead>
                                            <tr>
                                                <th width="10%">{strings.date}</th>
                                                <th>{strings.sta_hour_avg}</th>
                                                {
                                                    [...Array(24).keys()].map((item, index) => (
                                                        <th key={index}>{strings.formatString(strings.sta_hour_format, index)}</th>
                                                    ))
                                                }
                                            </tr>
                                        </thead>
                                        <tbody />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </PanelBody>
                </Panel>
            </div>
        )
    }
}

export default withRouter(inject('rootStore')(Hourly));